<template>
  <div id="hackathon" :section="sections[sectionIndex]" :nav-opened="navOpened" :header-color="headerColor" @click="navOpened = false">
    <!-- <header v-if="isMobile">
      <a @click.stop="navOpened = true"><i class="ic ic-menu"></i>Menu</a>
    </header> -->
    <div class="section-wrapper nav-wrapper">
      <nav class="nav" ref="nav" @click.stop>
        <a v-if="isMobile" class="menu-btn" @click="navOpened = false"><i class="ic ic-chevron-bottom-w"></i>Back</a>
        <a v-for="(section, i) in sections.filter(s => s !== 'footer' && s !== 'conference')" :key="section" :href="`#${section}`" @click.stop="selectSection(section)" :selected="sectionIndex === i">{{section.replace(/-/g, ' ')}}</a>
      </nav>
    </div>
    <main ref="main" :direction="direction">

      <section ref="conference" class="section spring" :position="getPosition(sectionIndex, 0)">
        <div class="section-wrapper">
          <div class="container">
            <div class="event-hashtag">#CASTfinalconference</div>
            <h1>{{settings.title}}</h1>
            <div class="event-date">{{settings.dates}}</div>
            <div class="event-location">{{settings.location}}</div>
            <a :href="settings.link" target="_blank" class="btn btn-ic">
              <span><i class="ic ic-plane"></i>Register now</span>
            </a>
            <a href="#schedule" @click="selectSection('schedule')" class="btn btn-ic">
              <i class="ic ic-schedule"></i>
              <span><i class="ic ic-list"></i>Schedule</span>
            </a>
          </div>
          <div class="sponsors">
            <div class="sponsor">
              <div class="sponsor-label">Produced by</div>
              <a href="http://www.ebn.eu/" target="_blank">
                <img src="@/assets/hackathon/h_logo_ebn.png" alt="EBN" class="sps-logo">
              </a>
            </div>
          </div>
          <div class="scroll">
            <div>Scroll</div>
            <i class="ic ic-chevron-bottom-w"></i>
          </div>
        </div>
      </section>

      <section ref="registration" class="section home" :position="getPosition(sectionIndex, 1)">
        <div class="section-wrapper">
          <div class="container" v-if="settings.details">
            <div class="introduction">
              <div class="event-hashtag">#CASTfinalconference</div>
              <h1>{{settings.title}}</h1>
              <p class="heavy">{{settings.details.title}}</p>
              <div class="description" v-html="settings.details.description"></div>
              <a :href="settings.link" target="_blank" class="btn btn-ic">
                <span><i class="ic ic-plane"></i>Register now</span>
              </a>
              <!-- <div class="note">Book your ticket for <a @click="selectSection('apply')">{{settings.title}}</a></div> -->
            </div>
          </div>
          <div class="photo-container" v-if="settings.details">
            <p>“ <span>{{settings.details.quote}}</span> ”</p>
            <a v-if="isMobile" href="#schedule" @click="selectSection('schedule')" class="btn btn-ic">
              <i class="ic ic-schedule"></i>
              <span><i class="ic ic-list"></i>Schedule</span>
            </a>
          </div>
          <div class="scroll">
            <div>Scroll</div>
            <i class="ic ic-chevron-bottom-w"></i>
          </div>
        </div>
      </section>

      <section ref="participants" class="section events" :position="getPosition(sectionIndex, 2)">
        <div class="event spring" v-if="settings.apply">
          <div class="event-container">
            <h2><span>{{settings.apply.left.title}}</span></h2>
            <div class="event-description" v-html="settings.apply.left.description"></div>
            <a :href="settings.link" target="_blank" class="btn btn-ic">
              <span><i class="ic ic-plane"></i>Register now</span>
            </a>
          </div>
        </div>
        <div class="event autumn" v-if="settings.apply">
          <div class="event-container">
            <h2><span>{{settings.apply.right.title}}</span></h2>
            <div class="event-description" v-html="settings.apply.right.description"></div>
          </div>
        </div>
        <div class="scroll">
          <div>Scroll</div>
          <i class="ic ic-chevron-bottom-w"></i>
        </div>
      </section>
      
      <section ref="schedule" class="section schedule" :position="getPosition(sectionIndex, 3)">
        <div class="section-wrapper">
          <div class="container">
            <i class="ic ic-schedule-b"></i>
            <h1>Schedule <span class="schedule-days"><a v-for="day in getDays(sessions)" :key="day" :selected="selectedDay === day" @click="selectedDay = day"><date-format :date="day" format="%Lm %d" /></a></span></h1>
            <div class="schedule-list">
              <div class="schedule-item" v-for="session in sessions.filter(s => selectedDay === formatDate(s.date))" :key="session.id">
                <div class="time">
                  <date-format :date="session.date" format="%h:%i %a" />
                </div>
                <div class="info">
                  <div class="description">{{session.title}}</div>
                  <div>{{session.subtitle}}</div>
                  <div class="speakers">
                    <div
                      class="speaker"
                      v-for="speaker in session.speakers.map(s => speakers.find(ss => s === ss.id)).filter(s => s)"
                      :key="`${session.id}-${speaker.id}`"
                    >
                      <a href="#people" @click="selectSpeaker(speaker.id)">{{speaker.name}}</a> - {{speaker.role}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <a v-if="!isMobile" href="#people" @click="selectSection('people')" class="btn btn-ic">
            <i class="ic ic-speaker-b"></i>
            <span><i class="ic ic-micro-b"></i>People</span>
          </a> -->
          <div class="scroll">
            <div>Scroll</div>
            <i class="ic ic-chevron-bottom"></i>
          </div>
        </div>
      </section>

      <section ref="people" class="section speakers" :position="getPosition(sectionIndex, 4)">
        <div class="section-wrapper">
          <div class="selector" v-if="speakers.length">
            <i class="ic ic-speakers"></i>
            <h1>People</h1>
            <div class="selector-list">
              <a
                class="option"
                v-for="type in speakerTypes.filter(t => speakers.findIndex(s => s.type === t) > -1)"
                :key="`type-${type}`"
                @click="selectSpeaker(type)"
                :selected="speakers[speakerIndex].type === type"
              >
                {{type}}
              </a>
            </div>
          </div>
          <div class="speaker-container">
            <div ref="speaker" class="speaker" v-for="(speaker, i) in speakers" :key="speaker.id" :style="{transform: `translateX(${-(i === speakerIndex ? i : i > speakerIndex ? i - 1 : i + 1) * 100}%)`}">
              <div class="speaker-photo-container">
                <div class="speaker-photo" :style="{backgroundImage: `url(${speaker.image})`}"></div>
                <div class="speaker-info">
                  <div class="speaker-name" v-html="speaker.name"></div>
                  <div class="speaker-type">{{speaker.type}}</div>
                </div>
              </div>
              <div class="speaker-profile">
                <div class="speaker-type">{{speaker.type}}</div>
                <h1 class="speaker-name" v-html="speaker.name"></h1>
                <div class="speaker-role">{{speaker.role}}</div>
                <div class="speaker-description" v-html="speaker.bio"></div>
              </div>
            </div>
          </div>
          <div class="speaker-selector">
            <a class="previous" @click="speakerIndex--" :disabled="speakerIndex === 0">
              <div class="speaker-preview" v-if="speakerIndex > 0">
                <div><b>{{speakers[speakerIndex - 1].name}}</b></div>
                <div>{{speakers[speakerIndex - 1].type}}</div>
              </div>
              <i class="ic ic-previous"></i>
            </a>
            <div class="current-speaker" v-if="speakers.length">
              <div class="speaker-name" v-html="speakers[speakerIndex].name"></div>
              <div class="speaker-type">{{speakers[speakerIndex].type}}</div>
            </div>
            <a class="next" @click="speakerIndex++" :disabled="speakerIndex >= speakers.length - 1">
              <i class="ic ic-next"></i>
              <div class="speaker-preview" v-if="speakerIndex < speakers.length - 1">
                <div><b>{{speakers[speakerIndex + 1].name}}</b></div>
                <div>{{speakers[speakerIndex + 1].type}}</div>
              </div>
            </a>
          </div>
          <div class="scroll">
            <div>Scroll</div>
            <i class="ic ic-chevron-bottom"></i>
          </div>
        </div>
      </section>

      <section ref="partners" class="section partners" :position="getPosition(sectionIndex, 5)">
        <div class="section-wrapper">
          <div class="container">
            <div class="section-title">
              <div class="ic ic-partners"></div>
              <h1>Partners</h1>
            </div>
          </div>
          <div class="partners-list" v-if="isMobile">
            <swiper ref="partnersSwiper" :options="{
              spaceBetween: 12,
              centeredSlides: false,
              slidesPerView: 3,
              slidesOffsetBefore: 24,
              breakpoints: {
                767: {
                  slidesPerView: 1.2,
                  centeredSlides: true,
                  slidesOffsetBefore: 0,
                },
              },
            }">
              <swiper-slide v-for="(partner, i) in partners" :key="partner.name">
                <a class="partner" :key="`partner-${i}`" :href="partner.link" target="_blank">
                  <img :src="partner.image" :alt="partner.name" class="partner-logo">
                </a>
              </swiper-slide>
            </swiper>
          </div>
          <div class="partners-container" v-else>
            <div class="sponsors">
              <div class="sponsor">
                <div class="sponsor-label">Produced by</div>
                <a href="http://www.ebn.eu/" target="_blank">
                  <img src="@/assets/hackathon/h_logo_ebn.png" alt="EBN" class="sps-logo">
                </a>
              </div>
            </div>
            <div class="partners-list">
              <a class="partner" v-for="(partner, i) in partners.slice(partnerIndex, partnerIndex + partnersPerPage)" :key="`partner-${i}`" :href="partner.link" target="_blank">
                <img :src="partner.image" :key="partner.id" :alt="partner.name" class="partner-logo">
                <div class="partner-title">{{partner.name}}</div>
              </a>
            </div>
          </div>
          <div class="partners-pagination" v-if="!isMobile">
            <a v-for="(index, i) in Math.ceil(partners.length / partnersPerPage)" class="page-link" :key="`partners-bullet-${index}`" :selected="partnerIndex === i * partnersPerPage" @click="partnerIndex = i * partnersPerPage"></a>
          </div>
          <div class="scroll">
            <div>Scroll</div>
            <i class="ic ic-chevron-bottom"></i>
          </div>
        </div>
      </section>

      <section ref="why-attend" class="section origin" :position="getPosition(sectionIndex, 6)">
        <div class="section-wrapper">
          <div class="container" v-if="settings.background">
            <i class="ic ic-origin"></i>
            <h1>Why attend</h1>
            <p class="heavy">{{settings.background.title}}</p>
            <p class="highlight">{{settings.background.subtitle}}</p>
            <div v-html="settings.background.description"></div>
          </div>
          <div class="gtc">
            <router-link to="/">
              <img src="@/assets/cast_logo.svg" alt="CAST - Virtual Hackathon" class="gtc-logo">
            </router-link>
            <div class="socials">
              <router-link to="/" class="social"><i class="ic ic-link"></i></router-link>
              <a href="https://twitter.com/CastnetworkE" target="_blank" class="social"><i class="ic ic-twitter"></i></a>
              <a href="https://www.linkedin.com/showcase/cast-network-eu/about/" target="_blank" class="social"><i class="ic ic-linkedin"></i></a>
            </div>
            <span>Follow us</span>
          </div>
        </div>
      </section>

    </main>
  </div>
</template>

<script>
import {Lethargy} from 'lethargy'
import {mapGetters} from 'vuex'
import DateFormat from '../components/DateFormat'

export default {
  name: 'hackathon',
  components: {
    DateFormat,
  },
  data() {
    return {
      sections: ['conference', 'registration', 'participants', 'schedule', 'people', 'partners', 'why-attend'],
      sectionIndex: -1,
      scrollReady: true,
      navOpened: false,
      headerColor: false,
      settings: {},
      direction: 'bottom',
      speakerIndex: 0,
      partnerIndex: 0,
      speakers: [],
      partners: [],
      sessions: [],
      selectedDay: null,
      speakerTypes: ['Speakers', 'Mentors & Trainers', 'Jurors', 'Hosts'],
      partnersPerPage: window.innerHeight > 840 ? 9 : 6,
      isMobile: window.innerWidth < 1024 || window.innerHeight <= 732,
    }
  },
  computed: {
    ...mapGetters({
      db: 'getDb',
    }),
    sectionHash() {
      return window.location.hash && window.location.hash.substring(1)
    }
  },
  watch: {
    sectionHash(hash) {
      this.selectSection(hash)
    },
    sectionIndex(index, previous) {
      this.direction = index > previous ? 'top' : 'bottom'
      this.$nextTick(() => {
        if('history' in window) window.history.replaceState(null, null, `#${this.sections[index]}`)
        if(this.isMobile) {
          let pos = this.$refs[this.sections[index]].getBoundingClientRect()
          window.scrollTo(0, pos.top + window.scrollY)
          window.dispatchEvent(new Event('scroll'))
        }
        else {
          clearTimeout(this.moveTO)
          this.moveTO = setTimeout(() => {
            this.sections.map((section, i) => {
              if(i === index) this.$refs[section].classList.add('selected')
              else this.$refs[section].classList.remove('selected')
            })
          }, 320)
        }
      })
    },
    navOpened(opened) {
      document.body.style.overflow = opened ? 'hidden' : null
    },
    speakerIndex(index, previous) {
      if(this.isMobile) return
      if(previous > -1) {
        this.$refs.speaker[previous].classList.remove('current')
        this.$refs.speaker[previous].classList.add(index > previous ? 'before' : 'after')
        setTimeout(() => this.$refs.speaker[previous].classList.remove('before', 'after'), 320)
      }
      if(index > -1) {
        this.$refs.speaker[index].classList.remove('before', 'after')
        this.$refs.speaker[index].classList.add('current')
      }
    },
    sessions(sessions) {
      const days = this.getDays(sessions)
      if(!this.selectedDay) this.selectedDay = days[0]
    },
  },
  methods: {
    selectSpeaker(hint) {
      if(this.speakerTypes.includes(hint)) {
        this.speakerIndex = this.speakers.findIndex(s => s.type === hint)
      }
      else this.speakerIndex = this.speakers.findIndex(s => s.id === hint)
      this.selectSection('people')
      if(this.isMobile && this.$refs.speaker && this.$refs.speaker[this.speakerIndex]) {
        const pos = this.$refs.speaker[this.speakerIndex].getBoundingClientRect()
        window.scrollTo(0, pos.top)
      }
    },
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
    },
    getDays(sessions) {
      return sessions.reduce((list, session) => {
        const date = this.formatDate(session.date)
        if(!list.includes(date)) list.push(date)
        return list
      }, [])
    },
    selectSection(hash) {
      this.sectionIndex = Math.max(this.sections.indexOf(hash), 0)
      this.navOpened = false
    },
    getPosition(section, index) {
      if(section > index) return 'before'
      if(section < index) return 'after'
      return 'current'
    },
    scrollSection(e) {
      // if(!this.scrollReady) return false
      // this.scrollTO = setTimeout(() => this.scrollReady = true, 320)
      // this.scrollReady = false
      if(e.deltaY > 0) {
        this.sectionIndex = Math.min(this.sectionIndex + 1, this.sections.length - 1)
      }
      else if(e.deltaY < 0) {
        this.sectionIndex = Math.max(this.sectionIndex - 1, 0)
      }
    },
    checkScroll(e) {
      if(this.isMobile) return false
      e.preventDefault()
      e.stopPropagation()
      if(this.lethargy.check(e) !== false) this.scrollSection(e)
      return false
    },
    handleScroll() {
      const index = ['schedule', 'partners', 'background', 'people'].findIndex(s => {
        if(!this.$refs[s]) return false
        const pos = this.$refs[s].getBoundingClientRect()
        if(pos.height === 0) return false
        return pos.top - 48 <= 0 && pos.top >= -pos.height + 48
      })
      this.headerColor = index > -1
    },
    disableTouchMove(e) {
      if(this.isMobile && this.navOpened) e.preventDefault()
    },
  },
  mounted: function() {
    this.lethargy = new Lethargy(10, 100, 0.1)
    this.selectSection(this.sectionHash);
    ['DOMMouseScroll', 'mousewheel', 'wheel'].map(x => {
      this.$refs.main.addEventListener(x, this.checkScroll)
    })
    window.addEventListener('scroll', this.handleScroll)
    document.addEventListener('touchmove', this.disableTouchMove, { passive: false })
    window.dispatchEvent(new Event('scroll'))
    this.settingsRef = this.db().collection('settings').doc('hackathon').onSnapshot(settings => {
      this.settings = settings.exists ? settings.data() : {}
      this.$store.commit('setPageLoading', false)
    })
    this.partnersRef = this.db().collection('settings/hackathon/partners').orderBy('name').onSnapshot(partners => {
      this.partners = partners.docs.map(partner => partner.data())
    })
    this.speakersRef = this.db().collection('settings/hackathon/speakers').onSnapshot(speakers => {
      this.speakers = speakers.docs
        .map(speaker => speaker.data())
        .sort((a, b) => this.speakerTypes.indexOf(a.type) - this.speakerTypes.indexOf(b.type))
    })
    this.sessionsRef = this.db().collection('settings/hackathon/sessions').orderBy('date').onSnapshot(sessions => {
      this.sessions = sessions.docs.map(session => ({
        ...session.data(),
        date: session.get('date').toDate(),
      }))
    })
  },
  beforeDestroy: function() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('touchmove', this.disableTouchMove, { passive: false })
    if(this.settingsRef) this.settingsRef()
    if(this.partnersRef) this.partnersRef()
    if(this.speakersRef) this.speakersRef()
    if(this.sessionsRef) this.sessionsRef()
  },
}
</script>

<style scoped>
#hackathon {
  position: relative;
  height: 100%;
  color: #fff;
}

a {
  cursor: pointer;
  color: inherit;
  text-decoration: none;
}

a[disabled] {
  pointer-events: none;
}

h1 {
  font: bold 40px/1 'Butler';
  margin: 0;
}

p {
  margin: 0;
}

img {
  max-width: 100%;
}

.ic {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  width: 38px;
  height: 38px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.ic.ic-laurel-round {
  background-image: url(../assets/hackathon/h_ic_laurel-round.svg);
}

.ic.ic-ticket {
  background-image: url(../assets/hackathon/h_ic_ticket.svg);
}

.ic.ic-origin {
  background-image: url(../assets/hackathon/h_ic_origin.svg);
}

.ic.ic-twitter {
  background-image: url(../assets/hackathon/h_ic_twitter.svg);
}

.ic.ic-facebook {
  background-image: url(../assets/hackathon/h_ic_facebook.svg);
}

.ic.ic-link {
  background-image: url(../assets/hackathon/h_ic_globe.svg);
}

.ic.ic-youtube {
  background-image: url(../assets/hackathon/h_ic_youtube.svg);
}

.ic.ic-linkedin {
  background-image: url(../assets/hackathon/h_ic_linkedin.svg);
}

.ic.ic-chevron-bottom {
  background-image: url(../assets/hackathon/h_ic_chevron-bottom.svg);
}

.ic.ic-chevron-bottom-w {
  background-image: url(../assets/hackathon/h_ic_chevron-bottom-w.svg);
}

.ic.ic-schedule {
  background-image: url(../assets/hackathon/h_ic_schedule.svg);
}

.ic.ic-schedule-b {
  background-image: url(../assets/hackathon/h_ic_schedule-b.svg);
}

.ic.ic-list {
  background-image: url(../assets/hackathon/h_ic_list.svg);
}

.ic.ic-speakers {
  background-image: url(../assets/hackathon/h_ic_speakers.svg);
}

.ic.ic-speaker {
  background-image: url(../assets/hackathon/h_ic_speaker.svg);
}

.ic.ic-speaker-b {
  background-image: url(../assets/hackathon/h_ic_speaker-b.svg);
}

.ic.ic-micro {
  background-image: url(../assets/hackathon/h_ic_micro.svg);
}

.ic.ic-micro-b {
  background-image: url(../assets/hackathon/h_ic_micro-b.svg);
}

.ic.ic-previous {
  background-image: url(../assets/hackathon/h_ic_previous.svg);
}

.ic.ic-next {
  background-image: url(../assets/hackathon/h_ic_next.svg);
}

.ic.ic-partners {
  background-image: url(../assets/hackathon/h_ic_partners.svg);
}

.ic.ic-menu {
  background-image: url(../assets/hackathon/h_ic_menu.svg);
}

.ic.ic-apply {
  background-image: url(../assets/hackathon/h_ic_apply.svg);
}

.ic.ic-plane {
  background-image: url(../assets/hackathon/h_ic_plane.svg);
}

.btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 260px;
  height: 52px;
  border-radius: 26px;
  padding: 0;
  margin: 0;
  background: #F77E22;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  transition: background .16s;
}

@media screen and (min-width: 1025px) {
  .btn:hover {
    background: #f7791a;
  }
}

.btn.btn-ic {
  position: relative;
  padding: 0;
}

.btn.btn-ic > .ic {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 6px;
  margin: auto;
}

.btn span {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn.btn-ic:hover > span {
  transform: none;
}

.btn span .ic {
  width: 14px;
  height: 14px;
  margin-right: 8px;
}

nav {
  position: absolute;
  display: block;
  top: 50vh;
  right: 0;
  margin-right: 40px;
  transform: translateY(-50%);
  text-align: right;
  text-transform: capitalize;
  transition: opacity .24s;
}

#hackathon[section="footer"] nav {
  opacity: 0;
}

nav a {
  position: relative;
  display: block;
  transition: color .24s;
  margin: 12px 0;
  font: bold 18px/1 'Butler';
  text-transform: capitalize;
}

nav a:after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: -32px;
  width: 6px;
  height: 6px;
  border: 4px solid;
  border-radius: 50%;
  margin: auto;
}

nav a[selected] {
  font-weight: bold;
}

main {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.section {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: transform .24s ease-out;
  will-change: transform;
}

.section-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 1346px;
  max-width: calc(100% - 96px);
  height: 100%;
  margin: 0 auto;
}

.section[position="before"] {
  transform: translateY(-100%);
}

.section[position="after"] {
  transform: translateY(100%);
}

main[direction="bottom"] .section[position="current"] {
  transform: translateY(2%);
}

main[direction="top"] .section[position="current"] {
  transform: translateY(-2%);
}

main .section.selected[position="current"] {
  transform: none;
  transition-duration: .16s;
}

.section .container {
  position: relative;
  z-index: 3;
}

.section .scroll {
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  text-align: center;
  line-height: 1;
  font-size: 12px;
  text-transform: uppercase;
  pointer-events: none;
  z-index: 2;
}

.section .scroll .ic {
  width: 7px;
  height: 7px;
}

.home .section-wrapper {
  align-items: flex-end;
}

.home .scroll {
  width: 842px;
  right: auto;
  max-width: 100%;
}

.home .container {
  position: relative;
  width: 536px;
  max-width: 100%;
  align-self: flex-start;
  margin-top: 20%;
  z-index: 4;
}

.home .photo-container {
  position: relative;
  overflow: hidden;
  width: 40%;
  height: 82.5%;
  background: url(../assets/hackathon/h_bg_how-it-works.jpg) no-repeat center/cover;
  z-index: 3;
  flex-shrink: 0;
  margin-left: 5.86%;
}

.home .photo-container:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  padding-top: 200%;
  opacity: .77;
  transform: translate(-50%, -50%);
  background: rgb(0,161,237);
  background: -moz-radial-gradient(circle, rgba(0,161,237,0.77) 0%, rgba(0,161,237,0) 100%);
  background: -webkit-radial-gradient(circle, rgba(0,161,237,0.77) 0%, rgba(0,161,237,0) 100%);
  background: radial-gradient(circle, rgba(0,161,237,0.77) 0%, rgba(0,161,237,0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00a1ed",endColorstr="#00a1ed",GradientType=1);
}

.home .photo-container p {
  position: relative;
  width: 220px;
  line-height: 20px;
  margin: 26px 0 0 36px;
  font-size: 12px;
  font-weight: bold;
  font-style: italic;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, .16);
}

.home .photo-container p::first-letter {
  font-size: 18px;
}

.home .introduction .description >>> * {
  color: #fff !important;
  font-size: 15px;
}

.home .introduction .description >>> a {
  color:#FFFB8D !important;
  text-decoration: underline;
}

.home .introduction .btn {
  margin-top: 52px;
}

.home .logo {
  display: block;
  height: 250px;
  margin-bottom: -42px;
  margin-left: -52px;
}

.home h1 {
  width: 738px;
  font: bold 52px/.92 'Butler';
  margin: 12px 0 32px;
}

.home .event-hashtag {
  font: bold 40px/1 'Butler';
}

.home .introduction p:not(.heavy) {
  font-size: 15px;
  font-weight: 600;
}

.container .heavy {
  font-size: 19px;
  font-weight: bold;
}

.container .highlight {
  font-weight: 600;
  margin-bottom: 20px;
  font-size: 16px;
}

.home .container .heavy {
  margin-bottom: 20px;
  font-size: 16px;
}

.home .introduction .note {
  color: #333;
  font-size: 11px;
  padding-left: 20px;
  margin-top: 26px;
}

.home .introduction .note a {
  color: #fff;
  text-decoration: underline;
}

/* .home .laurels:before,
.home .laurels:after {
  content: '';
  position: absolute;
  background: url(../assets/hackathon/h_ic_laurel.svg) no-repeat center/contain;
  opacity: .08;
  z-index: 1;
}

.home .laurels:before {
  top: 53.33%;
  left: 31.875%;
  width: 14%;
  height: 70%;
}

.home .laurels:after {
  bottom: 0;
  right: 3.675%;
  width: 24%;
  height: 118%;
  background-position: center bottom;
} */

.origin .section-wrapper {
  align-items: flex-start;
  background: url(../assets/hackathon/h_bg_origin.png) no-repeat 74% 76%/55% auto;
}

/* .origin:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 36.44%;
  width: 104px;
  height: 109px;
  background: url(../assets/hackathon/h_origin_laurels.svg) no-repeat center bottom/contain;
} */

.origin .photos {
  position: absolute;
  width: 38.25%;
  height: 83.85%;
  right: 16.25%;
  bottom: 4.16%;
  max-width: 612px;
  max-height: 805px;
}

.origin .photos .photo {
  position: absolute;
}

.origin .photos .photo:nth-child(1) {
  max-width: 31.86%;
  max-height: 23.85%;
  top: 0;
  left: 16.66%;
  z-index: 5;
}

.origin .photos .photo:nth-child(2) {
  max-width: 55.22%;
  max-height: 26.7%;
  top: 12.42%;
  right: 2.61%;
  z-index: 4;
}

.origin .photos .photo:nth-child(3) {
  max-width: 100%;
  max-height: 62.73%;
  top: 16.77%;
  right: 0%;
  z-index: 2;
}

.origin .photos .photo:nth-child(4) {
  max-width: 62%;
  max-height: 36%;
  top: 55.65%;
  left: 2.94%;
  z-index: 3;
}

.origin .photos .photo:nth-child(5) {
  max-width: 42.48%;
  max-height: 24.47%;
  top: 75.65%;
  right: 2.61%;
}

.origin .logo {
  position: absolute;
  top: 60px;
  right: 84px;
  width: 382px;
}

.origin .container {
  width: 39.1%;
  margin-top: 264px;
}

.origin .container h1 {
  font-family: 'poppins';
  margin-top: 24px;
}

.origin .container p {
  margin-top: 24px;
}

.origin .container .ic-origin {
  width: 28px;
  height: 28px;
}

.origin .container div >>> a {
  color:#FFFB8D;
  text-decoration: underline;
}

.origin .gtc {
  position: absolute;
  width: 180px;
  bottom: 120px;
  left: 0;
}

.origin .gtc .gtc-logo {
  display: block;
  width: 100%;
  margin-bottom: 10px;
}

.origin .gtc .social {
  display: inline-flex;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-right: 14px;
}

.origin .gtc .social:last-child {
  margin: 0;
}

.origin .gtc .social .ic {
  width: 14px;
  height: 12px;
}

.origin .gtc span {
  text-transform: uppercase;
  letter-spacing: .58em;
  font-size: 10px;
  margin-left: 12px;
  margin-top: 2px;
}

.events {
  display: flex;
  padding: 0;
  color: #fff;
}

/* .events:after {
  content: '';
  position: absolute;
  width: 188px;
  height: 58.54%;
  top: 50%;
  left: 0;
  right: 0;
  margin: auto;
  background: url(../assets/hackathon/h_ic_laurel.svg) no-repeat center/contain;
  opacity: .23;
} */

.events .event {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
  width: 50%;
  height: 100%;
  padding-bottom: 14%;
}

.events .event.spring {
  background: rgb(247, 126, 34) url(../assets/hackathon/h_bg_participants.jpg) no-repeat center bottom/100% auto;
}

.events .event.spring:before,
.events .event.autumn:before {
  content: '';
  position: absolute;
  padding-top: 67%;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(247, 126, 34);
  background: -moz-linear-gradient(180deg, rgba(247, 126, 34,1) 0%, rgba(172,99,44,0.77) 40%, rgba(51,26,8,0.69) 100%);
  background: -webkit-linear-gradient(180deg, rgba(247, 126, 34,1) 0%, rgba(172,99,44,0.77) 40%, rgba(51,26,8,0.69) 100%);
  background: linear-gradient(180deg, rgba(247, 126, 34,1) 0%, rgba(172,99,44,0.77) 40%, rgba(51,26,8,0.69) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#27a284",endColorstr="#0f3d32",GradientType=1);
}

.events .event.autumn {
  background: rgb(0, 161, 237) url(../assets/hackathon/h_bg_mentors.jpg) no-repeat center bottom/100% auto;
}

.events .event.autumn:before {
  background: rgb(0, 161, 237);
  background: -moz-linear-gradient(180deg, rgba(0, 161, 237,1) 0%, rgba(44,131,172,0.77) 40%, rgba(18,70,95,0.69) 100%);
  background: -webkit-linear-gradient(180deg, rgba(0, 161, 237,1) 0%, rgba(44,131,172,0.77) 40%, rgba(18,70,95,0.69) 100%);
  background: linear-gradient(180deg, rgba(0, 161, 237,1) 0%, rgba(44,131,172,0.77) 40%, rgba(18,70,95,0.69) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f15922",endColorstr="#0f3d32",GradientType=1);
}

.events .event.autumn .btn {
  position: relative;
  background: #00A1ED;
  overflow: hidden;
  margin: 0;
}

.events .event .event-container {
  position: relative;
  width: 380px;
  margin: auto;
  max-width: 100%;
}

.events .event img {
  display: block;
  width: 100%;
  margin-bottom: 50px;
}

.events .event h2 {
  position: relative;
  font: bold 52px/1 'Butler';
  margin-bottom: 18px;
}

.events .event h2 span {
  position: relative;
  display: block;
  z-index: 2;
}

.events .event .event-description {
  position: relative;
  font-size: 19px;
  line-height: 29px;
  margin-bottom: 50px;
  min-height: 172px;
}

.events .event .event-description >>> * {
  color: #fff !important;
}

.events .event .event-description >>> a {
  color:#FFFB8D !important;
  text-decoration: underline;
}

.section.spring .section-wrapper {
  flex-flow: column nowrap;
  align-items: flex-start;
}

.section.spring .section-wrapper:before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: 12%;
  width: 480px;
  height: 492px;
  border-radius: 8px;
  margin: auto;
  background: url(../assets/hackathon/h_top_bg.svg) no-repeat center/contain;
  pointer-events: none;
}

.section.partners .section-wrapper:after {
  top: 200px;
}

.section.schedule .section-wrapper .container:after {
  top: -38px;
  z-index: -1;
}

.spring .container {
  width: 738px;
  max-width: 100%;
  margin-top: 24%;
}

.spring .container .btn {
  margin-right: 40px;
}

.spring .container .logo {
  display: block;
  height: 250px;
  margin: 0 0 -32px -52px;
}

.spring .container h1 {
  font: bold 52px/.92 'Butler';
  margin-bottom: 18px;
}

.spring .container .event-location,
.spring .container .event-date {
  font-size: 19px;
  font-weight: 600;
}

.spring .container .event-location {
  margin-bottom: 32px;
}

.spring .event-hashtag {
  font: bold 40px/1 'Butler';
  margin-bottom: 12px;
}

.spring .sponsors {
  position: absolute;
  display: flex;
  left: 0;
  bottom: 100px;
}

.spring .sponsors .sponsor {
  margin-right: 28px;
}

.spring .sponsors .sponsor .sponsor-label {
  font-weight: 600;
  opacity: .77;
  margin-bottom: 8px;
}

.schedule .section-wrapper {
  flex-flow: column nowrap;
  align-items: flex-start;
}

.schedule .logo {
  position: absolute;
  top: 60px;
  right: 84px;
  width: 382px;
}

.schedule .container {
  margin-top: 200px;
  width: 100%;
}

.schedule .container > .ic {
  width: 28px;
  height: 28px;
}

.schedule .container > h1 {
  margin: 20px 0 10px;
  font-family: 'poppins';
}

.schedule .container > h1 a {
  font-size: 24px;
  margin-left: 16px;
}

.schedule .container > h1 a[selected] {
  color: #FFFB8D;
  text-decoration: underline;
}

.schedule .container > p {
  font-size: 11px;
  max-width: 586px;
}

.schedule .schedule-list {
  display: flex;
  width: calc(100% - 140px);
  height: 70vh;
  flex: 1;
  flex-direction: column;
  flex-wrap: wrap;
  margin-top: 26px;
}

.schedule .btn {
  position: absolute;
  display: flex;
  width: 260px;
  background: #fff;
  color: #00A1ED;
  margin: 0 auto;
  z-index: 2;
  bottom: 110px;
  left: 0;
  right: 0;
}

.schedule .schedule-item {
  position: relative;
  display: flex;
  width: 50%;
  margin-bottom: 40px;
  padding-right: 24px;
}

.schedule .schedule-item:before {
  content: '';
  position: absolute;
  width: 7px;
  height: 7px;
  left: 92px;
  top: 4px;
  background: #fff;
  border: 4px solid #F77E0B;
  border-radius: 50%;
  z-index: 1;
}

.schedule .schedule-item:not(:last-child):after {
  content: '';
  position: absolute;
  top: 11px;
  left: 98px;
  width: 2px;
  height: calc(100% + 40px);
  background: url(../assets/hackathon/h_schedule_line.svg) repeat-y center top/auto;
}

.schedule .schedule-item .time,
.schedule .schedule-item .description {
  font-weight: 600;
}

.schedule .schedule-item .time {
  width: 128px;
  flex-shrink: 0;
}

.schedule .schedule-item .speaker {
  font-size: 11px;
  margin-top: 6px;
}

.schedule .schedule-item .speaker a {
  color: #FFFB8D;
  text-decoration: underline;
}

.schedule > .btn {
  position: absolute;
  bottom: 102px;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 3;
}

.section.speakers .section-wrapper {
  flex-flow: column nowrap;
  justify-content: flex-end;
  align-self: center;
}

/* .section.speakers:before {
  content: '';
  position: absolute;
  width: 134px;
  height: 153px;
  background: url(../assets/hackathon/h_events_laurels-spring.svg) no-repeat center bottom/contain;
  bottom: 0;
  left: 13.25%;
} */

.speakers .logo {
  position: absolute;
  top: 60px;
  right: 84px;
  width: 382px;
}

.speakers .selector {
  position: absolute;
  top: 260px;
  left: 0;
  z-index: 2;
}

.speakers .selector h1 {
  font-family: 'poppins';
  margin-top: 20px;
}

.speakers .selector .ic {
  width: 28px;
  height: 28px;
}

.speakers .selector .option {
  position: relative;
  display: block;
  color:#fff;
  font-size: 19px;
  margin-top: 12px;
}

.speakers .selector .option[selected] {
  opacity: 1;
  font-weight: bold;
}

.speakers .selector .option[selected]:before {
  content: '';
  position: absolute;
  width: 7px;
  height: 7px;
  left: -12px;
  top: 0;
  bottom: 0;
  margin: auto;
  background: url(../assets/hackathon/h_ic_chevron-right-w.svg) no-repeat center/contain;
}

.speakers .speaker-container {
  position: relative;
  width: 755px;
  display: flex;
  align-items: flex-end;
  margin: 0 auto;
  overflow: hidden;
  z-index: 2;
}

.section.speakers .speaker {
  position: relative;
  display: flex;
}

.section.speakers .speaker.before,
.section.speakers .speaker.after,
.section.speakers .speaker.current {
  transition: transform .24s ease-out;
  will-change: transform;
}

.speakers .speaker .speaker-photo-container {
  width: 256px;
  flex-shrink: 0;
}

.speakers .speaker .speaker-photo-container .speaker-photo {
  position: relative;
  padding-top: 100%;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin-top: 42px;
  margin-bottom: 20px;
}

.speakers .speaker .speaker-photo-container .speaker-info {
  text-align: center;
  font-size: 13px;
}

.speakers .speaker .speaker-photo-container .speaker-info .speaker-name {
  text-transform: uppercase;
}

.speakers .speaker .speaker-photo-container .speaker-info .speaker-name span {
  text-transform: none;
}

.speakers .speaker .speaker-profile {
  width: 457px;
  flex-shrink: 0;
  margin-left: 42px;
}

.speakers .speaker .speaker-profile .speaker-type {
  opacity: .46;
  font-size: 19px;
}

.speakers .speaker .speaker-profile .speaker-name {
  text-transform: uppercase;
  font-family: 'poppins';
  margin: 8px 0 2px;
}

.speakers .speaker .speaker-profile .speaker-name span {
  text-transform: none;
}

.speakers .speaker .speaker-profile .speaker-role {
  font-weight: 600;
  line-height: 1;
  font-size: 19px;
  margin-top: 8px;
}

.speakers .speaker .speaker-profile .speaker-description {
  position: relative;
  margin-top: 24px;
  max-height: 420px;
  overflow: hidden;
}

.speakers .speaker .speaker-profile .speaker-description > * {
  font-size: 11px;
  line-height: 19px;
  margin-bottom: 24px;
}

.speakers .speaker .speaker-profile .speaker-description >>> * {
  color: #fff !important;
}

.speakers .speaker .speaker-profile .speaker-description >>> a {
  color:#FFFB8D !important;
  text-decoration: underline;
}

.speakers .speaker .speaker-profile .speaker-description *:last-child {
  margin: 0;
}

.speakers .speaker .speaker-profile .speaker-description h5 {
  margin-bottom: 16px;
}

.speakers .speaker .speaker-profile .speaker-description a {
  color:#27A284;
  text-decoration: underline;
}

.speaker-selector {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 64px 0 120px;
  z-index: 2;
}

.speaker-selector a {
  display: flex;
  align-items: center;
  font-size: 12px;
  width: 24px;
}

.speaker-selector a.previous {
  justify-content: flex-end;
}

.speaker-selector a .ic {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.speaker-selector a .speaker-preview {
  margin: 0 4px;
  flex-shrink: 0;
}

.speaker-selector .current-speaker {
  width: 300px;
  text-align: center;
  font-size: 13px;
}

.speaker-selector .current-speaker .speaker-name {
  text-transform: uppercase;
  font-weight: bold;
}

.speaker-selector .current-speaker .speaker-name span {
  text-transform: none;
}

.speaker-selector a[disabled] {
  opacity: .12;
}

.partners .section-wrapper {
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
  padding-top: 96px;
}

.partners > .logo {
  position: absolute;
  top: 60px;
  right: 84px;
  width: 382px;
}

.partners .sponsors {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  width: 220px;
  flex-shrink: 0;
  margin-right: 12px;
}

.partners .sponsors .sponsor {
  background: #fff;
  text-align: center;
  color:#00A1ED;
  border-radius: 4px;
  padding: 32px 0;
  margin: 12px 0;
}

.partners .container {
  display: flex;
}

.partners .container .section-title {
  width: 250px;
}

.partners .container .section-title .ic {
  width: 28px;
  height: 28px;
}

.partners .container .sponsor {
  margin-left: 44px;
}

.partners .partners-container {
  position: relative;
  display: flex;
  width: calc(100% - 254px);
  margin-top: 32px;
  z-index: 2;
}

.partners .container .sponsor .sponsor-label {
  font-weight: 600;
  margin-bottom: 8px;
}

.partners .container .sponsor .sps-logo {
  margin-right: 12px;
  max-width: 165px;
  height: 64px;
}

.partners .container h1 {
  margin-top: 20px;
  font-family: 'poppins';
}

.partners .partners-list {
  position: relative;
  display: flex;
  flex-flow: row wrap;
  flex-grow: 1;
  height: 456px;
  z-index: 2;
}

.partners .partners-pagination {
  position: relative;
  display: flex;
  margin: 0 0 0 232px;
  width: calc(100% - 534px);
  justify-content: center;
  align-items: center;
  margin-top: 56px;
}

.partners .partners-pagination a {
  display: block;
  width: 15px;
  height: 15px;
  background: #fff;
  border-radius: 50%;
  margin: 0 8px;
}

.partners .partners-pagination a[selected] {
  border: 4px solid #F77E0B;
}

.partners .partners-list .partner {
  position: relative;
  display: flex;
  width: calc(33.33333% - 24px);
  height: 116px;
  margin: 0 12px 50px 0;
  justify-content: center;
  align-items: center;
  background: #fff;
  border: 1px solid rgba(51, 51, 51, 0.12);
  border-radius: 4px;
}

.partners .partners-list .partner .partner-title {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 12px;
  margin-top: 8px;
}

.partners .partners-list .partner img {
  max-width: 80%;
  max-height: 80px;
}

.footer .section-wrapper {
  justify-content: center;
  align-items: flex-start;
  color: #fff;
  text-align: center;
}

/* .footer:before {
  content: '';
  position: absolute;
  width: 130px;
  height: 148px;
  background: url(../assets/hackathon/h_events_laurels-spring.svg) no-repeat center bottom/contain;
  bottom: 0;
  left: 84px;
}

.footer:after {
  content: '';
  position: absolute;
  background: url(../assets/hackathon/h_ic_laurel-b.svg) no-repeat center right/contain;
  z-index: 1;
  width: 410px;
  height: 128%;
  top: -19.375%;
  right: -205px;
} */

.nav-wrapper {
  height: auto;
  z-index: 10;
}

.footer .container {
  margin-top: 264px;
}

.footer .join {
  width: 764px;
  height: 162px;
  font-size: 27px;
  font-style: italic;
  line-height: 32px;
  font-family: 'Roboto Condensed';
  margin: auto;
  background: url(../assets/hackathon/h_bg_dialog.svg) no-repeat center/contain;
  padding: 26px 22px;
}

.footer .logo {
  display: block;
  width: 380px;
  margin: 82px auto 52px;
}

.footer .scroll {
  bottom: auto;
  top: 42px;
  pointer-events: all;
  cursor: pointer;
}

.footer .scroll .ic {
  transform: rotateZ(180deg);
}

@media screen and (min-width: 1024px) {
  .events .event.spring .event-container {
    margin: 0 0 0 auto;
    padding: 0 180px 0 64px;
    width: auto;
    max-width: 673px;
  }
  .events .event.autumn .event-container {
    margin: 0 auto 0 0;
    padding: 0 260px 0 64px;
    width: auto;
    max-width: 673px;
  }
  .origin .photos {
    width: 34%;
    height: 72%;
  }
}

@media screen and (max-height: 840px) {
  .home h1 {
    font-size: 36px;
    max-width: 100%;
  }
  .home .logo {
    display: none;
  }
  .home .event-hashtag {
    font-size: 28px;
  }
  .home .container {
    margin-top: 212px;
    align-self: flex-start;
  }
  .events .event {
    padding-bottom: 8%;
  }
  .schedule .container {
    margin-top: 212px;
  }
  .speakers .speaker .speaker-photo-container {
    width: 180px;
  }
  .speakers .speaker-container {
    width: 679px;
  }
  .speakers .speaker .speaker-profile .speaker-description {
    max-height: 206px;
    font-size: 14px;
  }
  .speaker-selector {
    margin: 48px 0 96px;
  }
  .partners .container {
    margin-top: 212px;
  }
  .spring .container {
    margin-top: 212px;
  }
  .spring .sponsors {
    bottom: 64px;
  }
  .partners .sponsors {
    width: 174px;
    justify-content: flex-start;
  }
  .partners .sponsors .sponsor {
    padding: 8px 0;
    margin: 0 0 38px;
  }
  .partners .sponsors .sponsor img {
    height: 64px;
  }
  .partners .partners-list {
    height: auto;
  }
  .partners .partners-list .partner {
    height: 106px;
    margin-bottom: 38px;
  }
  .partners .partners-pagination {
    margin-top: 24px;
  }
  .partners .container {
    margin-top: 188px;
  }
  .section.spring .section-wrapper {
    background: none;
  }
  .origin .container {
    margin-top: 212px;
  }
  .origin .gtc {
    bottom: 64px;
  }
  .origin .gtc .gtc-logo {
    display: none;
  }
  .events .event h2 {
    font-size: 40px;
  }
  .events .event .event-description {
    font-size: 16px;
  }
  .section .scroll {
    bottom: 24px;
  }
}

@media screen and (max-width: 1300px) {
  .section.spring .section-wrapper:before {
    width: 340px;
    height: 360px;
  }
}

@media screen and (max-width: 1023px),
screen and (max-height: 732px) {
  .section {
    position: relative;
    transform: none !important;
    min-height: 100vh;
    height: auto;
    padding: 0 32px;
    overflow: unset;
  }
  .section .section-wrapper {
    display: block;
    max-width: 100%;
  }
  .spring .container h1 {
    font-size: 40px;
  }
  .spring .event-hashtag {
    font-size: 24px;
  }
  main {
    height: auto !important;
  }
  #hackathon[section="about"], #hackathon[section="events"], #hackathon[section="spring"], #hackathon[section="footer"] {
    color: #333;
  }
  #hackathon:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9998;
    background: #1B705B;
    opacity: 0;
    pointer-events: none;
    transition: opacity .16s ease-out;
  }
  #hackathon[nav-opened]:before {
    opacity: .77;
  }
  nav {
    position: fixed;
    top: 0;
    left: 0;
    right: auto;
    bottom: 0;
    width: 100%;
    max-width: 310px;
    /* background:#27A284 url(../assets/hackathon/h_ic_laurels-b.svg) no-repeat bottom center/117px auto; */
    transform: translateX(-100%);
    transition: transform .16s ease-out;
    padding: 38px 0;
    z-index: 9999;
  }
  #hackathon[section="footer"] nav {
    opacity: 1;
  }
  nav a {
    text-align: left;
    padding: 20px 0 20px 96px;
    color: #fff;
    margin: 0;
  }
  nav a[selected] {
    background: rgba(51, 51, 51, 0.23);
  }
  nav .menu-btn {
    padding: 8px;
    margin-left: 38px;
    margin-bottom: 42px;
    font-weight: bold;
  }
  nav .menu-btn .ic {
    width: 14px;
    height: 14px;
    transform: rotateZ(90deg);
    margin-right: 4px;
    margin-top: -2px;
  }
  nav .menu-btn:after {
    display: none;
  }
  nav a:after {
    right: auto;
    left: 66px;
  }
  #hackathon[nav-opened] nav {
    transform: none;
  }
  header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    color: #fff;
    z-index: 100;
    padding: 28px 24px;
    font-weight: bold;
  }
  #hackathon[header-color] header {
    color:#27A284;
  }
  header > a {
    display: inline-block;
    padding: 8px;
  }
  header .ic {
    width: 22px;
    height: 22px;
    margin-right: 8px;
  }
  #hackathon[header-color] header .ic {
    background-image: url(../assets/hackathon/h_ic_menu-g.svg);
  }
  .section .scroll {
    display: none;
  }
  .section h1 {
    font-size: 36px;
  }
  .section.spring {
    margin-bottom: 0;
    padding-bottom: 80px;
    /* background-image: url(../assets/hackathon/h_m_bg_spring.jpg); */
  }
  .spring .sponsors {
    position: absolute;
    align-items: center;
    top: 100%;
    left: 0;
    right: 0;
    height: 127px;
    margin-top: -1px;
  }
  .spring .container {
    margin: 260px 0 0;
  }
  .section.spring .section-wrapper:before {
    display: none;
  }
  .spring .container .logo {
    margin-bottom: 36px;
  }
  .spring .container > .btn:last-child {
    display: none;
  }
  .spring .laurels {
    display: none;
  }
  .section.spring:after {
    background: rgb(39,162,132);
    background: -moz-linear-gradient(138deg, rgba(39,162,132,1) 0%, rgba(39,162,132,1) 15%, rgba(39,162,132,0.46) 72%, rgba(39,162,132,1) 95%);
    background: -webkit-linear-gradient(138deg, rgba(39,162,132,1) 0%, rgba(39,162,132,1) 15%, rgba(39,162,132,0.46) 72%, rgba(39,162,132,1) 95%);
    background: linear-gradient(138deg, rgba(39,162,132,1) 0%, rgba(39,162,132,1) 15%, rgba(39,162,132,0.46) 72%, rgba(39,162,132,1) 95%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#27a284",endColorstr="#27a284",GradientType=1);
  }
  .events .event h2::before {
    bottom: auto;
    top: -64px;
  }
  .spring .sponsors .sponsor {
    margin: 0 6px;
  }
  .spring .sponsors .sponsor .sponsor-label {
    font-size: 11px;
  }
  .spring .sponsors .sponsor .sps-logo {
    height: 32px;
    margin-right: 12px;
  }
  .spring .sponsors .sponsor a:last-child .sps-logo {
    margin: 0;
  }
  .home {
    display: block;
  }
  .schedule .schedule-list {
    display: block;
    width: auto;
    height: auto;
  }
  .schedule .schedule-item {
    width: 100%;
    padding: 0;
  }
  .home .container {
    margin: 0 0 48px;
  }
  .home .photo-container {
    position: relative;
    width: auto;
    height: 100vh;
    margin: 0 -32px;
    text-align: center;
  }
  .home .introduction {
    padding: 0;
  }
  .home .introduction .btn {
    display: flex;
    margin: 52px auto 0;
  }
  .home .introduction .note {
    padding: 0;
    text-align: center;
  }
  .home .introduction .note a {
    display: block;
  }
  .home .photo-container p {
    margin: 0;
    width: auto;
    padding: 75px 32px;
    font-size: 19px;
    line-height: 24px;
  }
  .home .laurels {
    display: none;
  }
  .home .photo-container .btn {
    position: absolute;
    bottom: 76px;
    left: 0;
    right: 0;
    margin: auto;
  }
  .origin {
    height: auto;
    display: block;
    padding-top: 0;
    padding-bottom: 70px;
    background-position: center 22%;
    background-image: url(../assets/hackathon/h_m_bg_origin.svg);
  }
  .origin .container {
    width: auto;
    margin-top: 50px;
  }
  .origin .logo {
    position: relative;
    top: auto;
    right: auto;
  }
  .origin .photos {
    position: relative;
    width: 350px;
    height: 525px;
    max-width: 100%;
    margin: 48px auto;
    right: auto;
    bottom: auto;
    background: url(../assets/hackathon/h_m_bg_origin@2x.png) no-repeat center/contain;
  }
  .origin .photos .photo {
    display: none;
  }
  .origin .gtc {
    position: relative;
    bottom: auto;
    left: auto;
    margin: 48px auto 0;
    z-index: 2;
    text-align: center;
  }
  .origin:after {
    display: none;
  }
  .section.partners .section-wrapper:before,
  .section.origin .section-wrapper:before,
  .section.spring .section-wrapper:after {
    display: none;
  }
  .origin .section-wrapper {
    background: none;
  }
  .events {
    display: block;
    padding: 0;
    height: auto;
  }
  .events:after {
    display: none;
  }
  .events .event {
    display: block;
    width: auto;
    height: auto;
    min-height: 100vh;
    padding: 96px 32px 48px;
  }
  .events .event.autumn,
  .events .event.spring {
    background-size: auto 53.2vh;
  }
  .events .event.autumn:after,
  .events .event.spring:after {
    display: none;
  }
  .events .event.spring:before, .events .event.autumn:before {
    padding-top: 0;
    height: 53.2vh;
    background-size: cover;
  }
  .events .event .btn {
    display: flex;
    margin: auto;
  }
  .events .event.spring .event-container,
  .events .event.autumn .event-container {
    width: auto;
    max-width: 480px;
    padding: 0;
    margin: auto;
  }
  .events .event.autumn:after {
    left: auto;
    right: 32px;
  }
  .events .event img,
  .events .event p {
    margin-bottom: 42px;
  }
  .schedule {
    display: block;
    padding-top: 96px;
    padding-bottom: 96px;
    height: auto;
  }
  /* .schedule:before {
    z-index: 2;
    background-image: url(../assets/hackathon/h_m_ic_laurels-w.svg);
    width: 74px;
    height: 84px;
    left: auto;
    right: 32px;
  } */
  .schedule:after {
    left: 0;
    right: 0;
    bottom: 0;
    top: auto;
    width: auto;
    height: 297px;
    background: url(../assets/hackathon/h_m_bg_schedule.jpg) no-repeat top center/cover;
  }
  .schedule .logo {
    position: relative;
    top: auto;
    right: auto;
  }
  .schedule .btn {
    position: relative;
    bottom: auto;
  }
  .schedule .container {
    width: auto;
    margin-top: 0;
  }
  .schedule .container > h1 .schedule-days {
    display: block;
  }
  .schedule .container > h1 a {
    margin: 0 16px 0 0;
    font-size: 16px;
  }
  .schedule .section-wrapper:after {
    display: none;
  }
  .speakers .speaker .speaker-profile .speaker-description {
    max-height: none;
  }
  .schedule > .btn {
    display: flex;
    position: relative;
    bottom: auto;
    z-index: 1;
    margin: auto;
  }
  .schedule .note {
    position: relative;
    width: 280px;
    margin: 140px auto 24px;
    z-index: 1;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
  }
  .schedule .speakers .speaker a {
    display: block;
  }
  .schedule .schedule-item .time, .schedule .schedule-item .description {
    line-height: 20px;
  }
  .schedule .schedule-item .speaker i {
    display: block;
  }
  .partners {
    padding: 0 32px;
    min-height: 0;
  }
  .partners > .logo {
    position: relative;
    right: auto;
    top: auto;
  }
  .partners .container {
    flex-flow: row wrap;
    margin-top: 0;
  }
  .partners .container .sponsor {
    margin: 0;
  }
  .partners .container .section-title {
    width: 100%;
    height: auto;
    background: none;
    margin-bottom: 24px;
  }
  .partners .container .sponsor:last-child {
    margin-left: 48px;
  }
  .partners .container .sponsor .sps-logo {
    min-height: 0;
    height: 42px;
    margin-right: 10px;
  }
  .partners .container .sponsor .sponsor-label {
    font-size: 12px;
  }
  .partners .partners-list {
    display: block;
    max-width: none;
    width: calc(100% + 64px);
    margin-left: -32px;
  }
  .partners .partners-list .partner {
    display: inline-flex;
    width: 100%;
    height: 160px;
    margin: 0;
  }
  .footer {
    padding-bottom: 48px;
  }
  .footer .join {
    width: 352px;
    height: 162px;
    font-size: 19px;
    line-height: 24px;
    padding: 24px 0;
    background-image: url(../assets/hackathon/h_m_ic_dialog.svg);
  }
  .footer .container {
    margin-top: 0;
  }
  .footer:before {
    left: 32px;
  }
  .footer:after {
    bottom: auto;
    top: 36px;
    height: 1226px;
    right: -190px;
  }
  .section.speakers {
    display: block;
    padding-top: 0;
  }
  .speakers .logo {
    position: relative;
    right: auto;
    top: auto;
  }
  .speakers .selector {
    position: relative;
    top: auto;
    left: auto;
    margin-top: 0;
  }
  .speakers .selector .selector-list {
    display: none;
  }
  .speakers .speaker-container {
    display: block;
    width: auto;
  }
  .speakers .speaker-container .speaker {
    display: block;
    transform: none !important;
    margin-bottom: 96px;
  }
  .speakers .speaker .speaker-photo-container .speaker-photo {
    width: 206px;
    height: 206px;
    padding: 0;
  }
  .speakers .speaker .speaker-photo-container .speaker-photo:after {
    width: 16px;
    height: 16px;
    border-width: 4px;
    right: 18px;
    bottom: 18px;
  }
  .speakers .speaker .speaker-profile {
    margin: 0;
    width: auto;
  }
  .speakers .speaker .speaker-photo-container .speaker-info,
  .speaker-selector,
  .section.speakers:before {
    display: none;
  }
  .speakers .speaker .speaker-profile .speaker-description {
    margin-top: 12px;
  }
  .speakers .speaker .speaker-profile .speaker-description h5 {
    margin-bottom: 12px;
  }
  .speakers .speaker .speaker-profile .speaker-name {
    margin-bottom: 24px;
  }
  .speakers .speaker .speaker-profile .speaker-type {
    position: absolute;
    top: 166px;
    left: 194px;
    font-size: 14px;
  }
  .speakers .speaker .speaker-profile .speaker-description > * {
    font-size: 14px;
    line-height: 21px;
  }
}

@media screen and (max-width: 413px) {
  .partners .container {
    display: block;
  }
  .partners .container .sponsor:last-child {
    margin: 16px 0 0;
  }
  .footer .join {
    width: 100%;
    font-size: 14px;
    padding: 24px 8px;
  }
}

@media screen and (max-width: 1023px) and (max-height: 570px) {
  nav {
    padding: 16px 0;
  }
  nav .menu-btn {
    margin-bottom: 16px;
  }
  nav a:not(.menu-btn) {
    padding: 10px 0 10px 96px;
  }
}
</style>
